import React from 'react';
import PropTypes from 'prop-types';
import { Card, Nav, Tab } from 'react-bootstrap';
import SimpleBarReact from 'simplebar-react';
import JobTable from './jobIndex';
import JobTableCompleted from './completed/index';

function TimeSheetCard() {
  const TabTitle = ({ title }) => (
    <div className="p-2 pe-4 text-start cursor-pointer">
      <h6 className="text-800 fs-8 text-nowrap">{title}</h6>
    </div>
  );

  TabTitle.propTypes = {
    title: PropTypes.string.isRequired
  };

  return (
    <Tab.Container id="audience-tab" defaultActiveKey="Need Review">
      <SimpleBarReact>
        <Card.Header className="p-0 bg-body-tertiary">
          <Nav className="nav-tabs border-0 flex-nowrap chart-tab">
            <Nav.Item>
              <Nav.Link className="mb-0" eventKey="Need Review">
                <TabTitle title="Needs Review" />
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link className="mb-0" eventKey="Completed">
                <TabTitle title="Completed" />
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </Card.Header>
      </SimpleBarReact>

      <Card.Body>
        <Tab.Content>
          <Tab.Pane unmountOnExit eventKey="Need Review">
            <JobTable />
          </Tab.Pane>
          <Tab.Pane unmountOnExit eventKey="Completed">
            <JobTableCompleted />
          </Tab.Pane>
        </Tab.Content>
      </Card.Body>
    </Tab.Container>
  );
}

export default TimeSheetCard;
